import { render, staticRenderFns } from "./myHaggle.vue?vue&type=template&id=736a81e8&scoped=true&"
import script from "./myHaggle.vue?vue&type=script&lang=js&"
export * from "./myHaggle.vue?vue&type=script&lang=js&"
import style0 from "./myHaggle.vue?vue&type=style&index=0&id=736a81e8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736a81e8",
  null
  
)

export default component.exports